import { render } from "./footer-newsletter-signup-modal.vue?vue&type=template&id=8da3848e"
import script from "./footer-newsletter-signup-modal.vue?vue&type=script&lang=js"
export * from "./footer-newsletter-signup-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__